export function ThankYouScreen() {
  return (
    <div className="absolute inset-0 z-[100] bg-black flex flex-col items-center justify-center animate-fade-in">
      <div className="relative w-20 h-20 mb-6 animate-scale-in">
        <div className="absolute inset-0 bg-brand-500/20 rounded-full blur-xl animate-pulse" />
        <svg
          className="w-full h-full text-brand-500 drop-shadow-[0_0_15px_rgba(42,71,66,0.6)]"
          viewBox="0 0 52 52"
        >
          <circle
            className="stroke-current text-brand-500/30"
            cx="26"
            cy="26"
            r="25"
            fill="none"
            strokeWidth="2"
          />
          <path
            className="animate-draw-check stroke-current fill-none"
            strokeWidth="4"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h2
        className="text-2xl md:text-3xl font-bold text-white mb-2 animate-fade-in-up"
        style={{ animationDelay: '0.8s' }}
      >
        Interview Completed
      </h2>
      <p
        className="text-sm text-gray-400 animate-fade-in-up mb-8"
        style={{ animationDelay: '1.2s' }}
      >
        Thank you for taking time to take the interview
      </p>
      <div className="animate-fade-in-up" style={{ animationDelay: '1.5s' }}>
        <a
          href="https://bo-smart.com"
          target="_blank"
          rel="noopener noreferrer"
          className="px-6 py-3 bg-brand-600 hover:bg-brand-500 text-white rounded-xl font-semibold transition-all shadow-lg hover:shadow-brand-500/25 inline-flex items-center gap-2"
        >
          Return to BO-SMART
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>
        <p className="text-xs text-gray-500 text-center mt-3">
          You&apos;ll be redirected to bo-smart.com in about 10 seconds.
        </p>
      </div>
    </div>
  )
}
